import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-delete',
  templateUrl: './page-delete.component.html',
  styleUrls: ['./page-delete.component.scss']
})
export class PageDeleteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
